<template>
  <ul class="nav_controler list-unstyled">
    <li>
      <a class="btn btn-link up"
        href="javascript:;"
        :class="{disabled: btnText.up === '', 'green': btnText.up === 'Yes'}"
        @click="funcHandleUp('arrowUp')"
        :disabled="btnText.up === ''"
        id="diagnosisBtnUp">
        <i class="fa fa-play"></i>
        <p>{{ btnText.up }}</p>
      </a>
    </li>
    <li>
      <a class="btn btn-link down"
        href="javascript:;"
        :class="{disabled: btnText.down === '', 'red': btnText.down === 'No'}"
        @click="funcHandleDown('arrowDown')"
        :disabled="btnText.down === ''"
        id="diagnosisBtnDown">
        <i class="fa fa-play"></i>
        <p>{{ btnText.down }}</p>
      </a>
    </li>
    <li :class="{displayBtn: isHidePower}">
      <a class="btn btn-link power"
        href="javascript:;"
        :class="{disabled: isHidePower}"
        ref="modal"
        @click="funcHandlePower('power')"
        :disabled="isHidePower"
        id="diagnosisBtnPower"
        >
        <i class="icon-power"></i>
        <p :class="{isHidePowerText: isHidePower}">{{ btnText.power }}</p>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'DiagnosisOperator',
  props: {
    btnText: Object,
    isHidePower: Boolean,
    modalOpen: Boolean,
    btnHmi: Object
  },
  data () {
    return {
      changeBtnText: this.btnText
    };
  },
  watch: {
    // BUGGGG
    btnText (val) {
      if (this.$route.meta.id === 'hmi') {
        this.$emit('specialHmi', this.btnText);
      }
    },
    btnHmi (val) {
      if (this.$route.meta.id === 'hmi') {
        this.$emit('specialHmi', this.btnText);
      }
    },
    modalOpen (val) {
      if (val) {
        this.$refs.modal.setAttribute('data-toggle', 'modal');
        this.$refs.modal.setAttribute('data-target', '#bike_Testing');
        this.$refs.modal.setAttribute('data-backdrop', 'static');
      } else {
        this.$refs.modal.removeAttribute('data-toggle', 'modal');
        this.$refs.modal.removeAttribute('data-target', '#bike_Testing');
        this.$refs.modal.removeAttribute('data-backdrop', 'static');
      }
    }
  },
  methods: {
    funcHandleUp (key) {
      if (this.btnText.up !== '') this.$emit('keyUpEvent', key);
    },
    funcHandleDown (key) {
      if (this.btnText.down !== '') this.$emit('keyDownEvent', key);
    },
    funcHandlePower (power) {
      if (!this.isHidePower) this.$emit('keyPowerEvent', power);
    }
  }
};
</script>
